/* ============================================================
   Candle Stick Candle — coming soon
   Canvas candlestick tape where every candle carries a flame.

   Exposes window.CandleStickCandle.init(root) / destroy(root) so the
   Shopify theme editor can rebuild the section without leaking a
   requestAnimationFrame loop each time a setting changes.
   ============================================================ */
(function () {
  "use strict";

  var INSTANCES = new WeakMap();

  function readConfig(root) {
    var tag = root.querySelector("[data-csc-config]");
    var cfg = {};
    if (tag) {
      try { cfg = JSON.parse(tag.textContent); } catch (err) { cfg = {}; }
    }
    return {
      bull: cfg.bull || "#3FD96B",
      bear: cfg.bear || "#F04A38",
      density: Math.max(12, Math.min(40, cfg.density || 22)),
      autoAdvance: cfg.autoAdvance !== false,
      interactive: cfg.interactive !== false,
      embers: cfg.embers !== false,
      gusts: cfg.gusts !== false
    };
  }

  /* "#3FD96B" -> "63,217,107" so the painter can vary alpha per bar */
  function rgbOf(hex) {
    var h = String(hex).trim().replace("#", "");
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    if (isNaN(n)) return "255,255,255";
    return ((n >> 16) & 255) + "," + ((n >> 8) & 255) + "," + (n & 255);
  }

  function init(root) {
    if (!root || INSTANCES.has(root)) return;

    var C = root.querySelector("[data-csc-canvas]");
    if (!C || !C.getContext) return;

    var cfg = readConfig(root);
    var ctx = C.getContext("2d", { alpha: true });
    var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var BULL = rgbOf(cfg.bull);
    var BEAR = rgbOf(cfg.bear);

    var W = 0, H = 0, DPR = 1;
    var N = 480;
    var SERIES = [];
    var LIT = [];

    /* ---------- the tape ----------
       It has to loop forever without a seam, so the price curve is built from
       sinusoids whose periods divide N exactly: bar N-1 hands off to bar 0 with
       no discontinuity and the chart can be scrubbed in either direction all day. */
    (function build() {
      var COMPS = [[3, 5.5, 0.4], [7, 3.2, 1.1], [19, 1.9, 2.3],
                   [53, 1.15, 0.7], [101, 0.8, 4.1], [173, 0.5, 2.0]];
      var P = [], i, k;
      for (i = 0; i < N; i++) {
        var v = 30;
        for (k = 0; k < COMPS.length; k++) {
          v += COMPS[k][1] * Math.sin((2 * Math.PI * COMPS[k][0] * i) / N + COMPS[k][2]);
        }
        P.push(v);
      }
      var s = 20260901;
      function rnd() { s = (s * 1664525 + 1013904223) % 4294967296; return s / 4294967296; }
      for (i = 0; i < N; i++) {
        var o = P[i], c = P[(i + 1) % N];
        SERIES.push({
          o: o, c: c,
          h: Math.max(o, c) + rnd() * 1.5 + 0.35,
          l: Math.min(o, c) - rnd() * 1.5 - 0.35,
          seed: rnd() * 100
        });
        LIT.push(true);
      }
    })();

    /* pre-rendered glow sprite — far cheaper than a gradient per flame per frame */
    var glow = document.createElement("canvas");
    glow.width = glow.height = 128;
    (function () {
      var g = glow.getContext("2d");
      var rg = g.createRadialGradient(64, 64, 0, 64, 64, 64);
      rg.addColorStop(0.00, "rgba(255,214,140,0.95)");
      rg.addColorStop(0.22, "rgba(255,169,46,0.42)");
      rg.addColorStop(0.55, "rgba(255,120,30,0.13)");
      rg.addColorStop(1.00, "rgba(255,110,30,0)");
      g.fillStyle = rg;
      g.fillRect(0, 0, 128, 128);
    })();

    var pan = 0, scrollY = 0, lastScroll = 0, scrollVel = 0;
    var dragOffset = 0, dragVel = 0, dragging = false, dragX = 0, dragMoved = 0;
    var lastTapAt = 0, lastTapX = 0, lastTapY = 0;
    var gust = 0, nextGust = 0, relight = [];
    var wind = 0, windTarget = 0;
    var mouse = { x: -999, y: -999, vx: 0, px: -999, over: false };
    var embers = [];
    var snuffAt = -1;
    var printed = 0, lastPrintAt = 0;
    var PRINT_MS = 1500, SHIFT_MS = 420;
    var torch = { x: 0, y: 0, tx: 0, ty: 0, r: 960, tr: 960, on: false };
    var SP = 46, BW = 20, viewLo = 0, viewHi = 1;
    var raf = 0, resizeTimer = 0, torchIdle = 0, torchTimer = 0;

    var stage = root.querySelector("[data-csc-stage]");
    var photo = root.querySelector("[data-csc-photo]");
    var hud = root.querySelector("[data-csc-lit]");
    var clockEl = root.querySelector("[data-csc-clock]");
    var title = root.querySelector(".csc-hero-title");
    var floats = root.querySelectorAll("[data-csc-float]");

    function resize() {
      DPR = Math.min(2, window.devicePixelRatio || 1);
      W = C.clientWidth; H = C.clientHeight;
      if (!W || !H) return;
      C.width = Math.round(W * DPR);
      C.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      SP = Math.max(21, Math.min(62, W / cfg.density));
      BW = SP * 0.46;
    }

    function roundRect(c, x, y, w, h, r) {
      r = Math.min(r, w / 2, h / 2);
      c.beginPath();
      c.moveTo(x + r, y);
      c.arcTo(x + w, y, x + w, y + h, r);
      c.arcTo(x + w, y + h, x, y + h, r);
      c.arcTo(x, y + h, x, y, r);
      c.arcTo(x, y, x + w, y, r);
      c.closePath();
    }

    function drawFlame(c, x, y, w, h, lean, alpha) {
      var tipX = x + lean * h * 0.42;
      var tipY = y - h;
      var g = c.createLinearGradient(x, y, tipX, tipY);
      g.addColorStop(0.00, "rgba(255,246,214," + (0.95 * alpha).toFixed(3) + ")");
      g.addColorStop(0.26, "rgba(255,201,92," + (0.92 * alpha).toFixed(3) + ")");
      g.addColorStop(0.62, "rgba(255,138,30," + (0.66 * alpha).toFixed(3) + ")");
      g.addColorStop(1.00, "rgba(240,74,56,0)");
      c.fillStyle = g;
      c.beginPath();
      c.moveTo(x, y);
      c.bezierCurveTo(x + w, y - h * 0.18, x + w * 1.02 + lean * h * 0.12, y - h * 0.55, tipX, tipY);
      c.bezierCurveTo(x - w * 1.02 + lean * h * 0.12, y - h * 0.55, x - w, y - h * 0.18, x, y);
      c.closePath();
      c.fill();

      var hw = w * 0.44, hh = h * 0.52;
      var cx2 = x + lean * hh * 0.3;
      c.fillStyle = "rgba(255,252,238," + (0.8 * alpha).toFixed(3) + ")";
      c.beginPath();
      c.moveTo(x, y);
      c.bezierCurveTo(x + hw, y - hh * 0.2, x + hw, y - hh * 0.6, cx2, y - hh);
      c.bezierCurveTo(x - hw, y - hh * 0.6, x - hw, y - hh * 0.2, x, y);
      c.closePath();
      c.fill();
    }

    function barAt(clientX) {
      var r = C.getBoundingClientRect();
      var idx = Math.round((clientX - r.left + pan - W * 0.5) / SP);
      return (((idx % N) + N) % N);
    }

    function igniteAll() { for (var i = 0; i < N; i++) LIT[i] = true; }

    function snuffAll() {
      for (var i = 0; i < N; i++) LIT[i] = false;
      snuffAt = performance.now();
    }

    function burst(x, y) {
      if (!cfg.embers) return;
      for (var i = 0; i < 14; i++) {
        embers.push({
          x: x, y: y,
          vx: (Math.random() - 0.5) * 1.6,
          vy: -Math.random() * 1.9 - 0.4,
          life: 1,
          size: Math.random() * 1.8 + 0.7
        });
      }
    }

    /* ---------- listeners ---------- */
    function onResize() { clearTimeout(resizeTimer); resizeTimer = setTimeout(resize, 120); }
    var risers = null;
    function revealRemaining() {
      if (!risers) risers = root.querySelectorAll(".csc-rise");
      for (var i = 0; i < risers.length; i++) risers[i].classList.add("is-in");
    }

    function onScroll() {
      scrollY = window.scrollY || 0;
      /* Anything still hidden once the page bottoms out can never satisfy the
         observer, so reveal it outright rather than leaving it invisible. */
      if (scrollY + window.innerHeight >= document.body.scrollHeight - 60) {
        revealRemaining();
      }
    }

    /* The light tracks the cursor from anywhere on the page and settles on the
       nearest point of the ACTUAL TYPE. Clamping to the element box is not
       enough: the headline wraps, so its box is far wider than the short line,
       and the light would sit in empty margin. Line boxes come from a Range,
       which gives one rect per rendered line. */
    var lineRects = null, lineRectsKey = "";
    function titleLineRects() {
      var key = window.scrollY + "x" + window.innerWidth + "x" + window.innerHeight;
      if (lineRects && lineRectsKey === key) return lineRects;
      var range = document.createRange();
      range.selectNodeContents(title);
      var rects = range.getClientRects();
      lineRects = [];
      for (var i = 0; i < rects.length; i++) {
        if (rects[i].width > 1 && rects[i].height > 1) lineRects.push(rects[i]);
      }
      if (!lineRects.length) lineRects.push(title.getBoundingClientRect());
      lineRectsKey = key;
      return lineRects;
    }

    function onTorchMove(e) {
      if (!title) return;
      var rects = titleLineRects();
      var box = title.getBoundingClientRect();
      var bestX = 0, bestY = 0, bestD = Infinity;
      for (var i = 0; i < rects.length; i++) {
        var r = rects[i];
        var cx = Math.max(r.left, Math.min(r.right, e.clientX));
        var cy = Math.max(r.top, Math.min(r.bottom, e.clientY));
        var dx = e.clientX - cx, dy = e.clientY - cy;
        var d = dx * dx + dy * dy;
        if (d < bestD) { bestD = d; bestX = cx; bestY = cy; }
      }
      /* the further away the cursor, the tighter the pool it casts */
      /* A wide, softly-ramped pool that eases toward the cursor in the render
         loop rather than snapping on every pointer event — it reads as the type
         lightening on one side, not as a disc sliding around. */
      torch.tx = bestX - box.left;
      torch.ty = bestY - box.top;
      torch.tr = 960 - Math.min(180, Math.sqrt(bestD) * 0.14);
      torch.on = true;
      torchIdle = 0;
    }

    function onCanvasMove(e) {
      var r = C.getBoundingClientRect();
      mouse.vx = mouse.px < -900 ? 0 : e.clientX - mouse.px;
      mouse.px = e.clientX;
      mouse.x = e.clientX - r.left;
      mouse.y = e.clientY - r.top;
      mouse.over = true;
    }
    function onLeave() { mouse.over = false; mouse.x = -999; }

    function onDown(e) {
      if (!cfg.interactive) return;
      if (e.target && e.target.closest &&
          e.target.closest("input, button, a, form, summary, details")) return;
      dragging = true; dragX = e.clientX; dragMoved = 0; dragVel = 0;
    }
    function onMove(e) {
      if (!dragging) return;
      var d = e.clientX - dragX;
      dragX = e.clientX;
      dragMoved += Math.abs(d);
      dragOffset -= d;
      dragVel = -d;
    }
    /* Touch has no space bar. Press-and-hold would trip the OS text-selection
       callout, so a double-tap snuffs the tape instead: two taps close together
       in time and place. The first tap still lights its candle immediately, so
       the single-tap gesture keeps its snap. */
    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      if (dragMoved >= 6) return;

      var t = performance.now();
      var isDouble = t - lastTapAt < 320 &&
                     Math.abs(e.clientX - lastTapX) < 34 &&
                     Math.abs(e.clientY - lastTapY) < 34;
      if (isDouble) {
        lastTapAt = 0;
        snuffAll();
        if (navigator.vibrate) { try { navigator.vibrate(18); } catch (err) {} }
        return;
      }
      lastTapAt = t; lastTapX = e.clientX; lastTapY = e.clientY;

      var i = barAt(e.clientX);
      LIT[i] = !LIT[i];
      if (LIT[i]) {
        var r = C.getBoundingClientRect();
        burst(e.clientX - r.left, e.clientY - r.top);
      }
    }
    function onCancel() { dragging = false; }

    function onKey(e) {
      if (!cfg.interactive) return;
      var tag = (e.target.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea") return;
      if (e.code === "Space") {
        e.preventDefault();
        snuffAll();
      }
    }

    /* ---------- frame ---------- */
    function frame(now) {
      raf = requestAnimationFrame(frame);
      if (document.hidden || !W || !H) return;

      scrollVel += ((scrollY - lastScroll) - scrollVel) * 0.2;
      lastScroll = scrollY;
      if (!dragging) { dragOffset += dragVel; dragVel *= 0.93; }

      /* The tape prints rather than glides. A bar closes on the interval, the
         chart steps left by exactly one column with a quick ease, then rests
         while the next bar forms in place at the right edge. */
      if (!REDUCED && cfg.autoAdvance) {
        if (!lastPrintAt) lastPrintAt = now;
        while (now - lastPrintAt >= PRINT_MS) {
          printed += 1;
          lastPrintAt += PRINT_MS;
          if (now - lastPrintAt > PRINT_MS * 4) { lastPrintAt = now; break; }
        }
      }
      var sincePrint = now - (lastPrintAt || now);
      var slide = Math.min(1, Math.max(0, sincePrint / SHIFT_MS));
      slide = 1 - Math.pow(1 - slide, 3);
      var formT = Math.min(1, Math.max(0, sincePrint / PRINT_MS));
      formT = formT * formT * (3 - 2 * formT);
      pan = (printed + slide) * SP + scrollY * 0.62 + dragOffset;

      /* a draught crosses the room every so often; a hard one blows one out */
      if (!REDUCED && cfg.gusts && now > nextGust) {
        gust = (Math.random() < 0.5 ? -1 : 1) * (0.75 + Math.random() * 0.85);
        nextGust = now + 9000 + Math.random() * 11000;
        if (Math.abs(gust) > 1.35) {
          var victim = barAt(Math.random() * W + C.getBoundingClientRect().left);
          if (LIT[victim]) {
            LIT[victim] = false;
            relight.push({ i: victim, at: now + 2600 + Math.random() * 2600 });
          }
        }
      }
      gust *= 0.986;
      for (var rq = relight.length - 1; rq >= 0; rq--) {
        if (now >= relight[rq].at) { LIT[relight[rq].i] = true; relight.splice(rq, 1); }
      }

      windTarget = Math.max(-1.7, Math.min(1.7,
        scrollVel * 0.028 + mouse.vx * 0.010 + dragVel * 0.02 + gust + Math.sin(now / 2300) * 0.2));
      wind += (windTarget - wind) * 0.06;
      mouse.vx *= 0.86;

      var visCount = Math.ceil(W / SP) + 3;
      if (snuffAt > 0) {
        var elapsed = now - snuffAt;
        var k = Math.floor(elapsed / 58);
        var base = Math.floor((pan - W * 0.5) / SP) - 1;
        for (var z = 0; z <= Math.min(k, visCount); z++) {
          LIT[(((base + z) % N) + N) % N] = true;
        }
        if (elapsed > visCount * 58 + 400) { igniteAll(); snuffAt = -1; }
      }

      ctx.clearRect(0, 0, W, H);

      var first = Math.floor((pan - W * 0.5) / SP) - 1;
      var count = visCount;

      /* Measure the range over a window wider than the screen and pad it, so a
         tall bar sliding in from the edge is already inside the scale before it
         appears — otherwise a narrow viewport throws candles off the band. */
      var lo = 1e9, hi = -1e9;
      for (var q = -2; q < count + 2; q++) {
        var b0 = SERIES[(((first + q) % N) + N) % N];
        if (b0.l < lo) lo = b0.l;
        if (b0.h > hi) hi = b0.h;
      }
      var padr = (hi - lo) * 0.05 + 0.2;
      lo -= padr; hi += padr;
      viewLo += (lo - viewLo) * 0.10;
      viewHi += (hi - viewHi) * 0.10;

      var top = H * (W < 640 ? 0.66 : 0.61), bot = H * 0.94;
      var span = (viewHi - viewLo) || 1;
      function Y(v) { return bot - ((v - viewLo) / span) * (bot - top); }

      ctx.strokeStyle = "rgba(120,140,160,0.05)";
      ctx.lineWidth = 1;
      for (var g2 = 0; g2 <= 4; g2++) {
        var gy = Math.round(top + ((bot - top) / 4) * g2) + 0.5;
        ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W, gy); ctx.stroke();
      }

      var flames = [];
      var liveAbs = Math.floor((pan + W * 0.5) / SP);

      for (var i2 = 0; i2 < count; i2++) {
        var absIdx = first + i2;
        var idx = ((absIdx % N) + N) % N;
        var bar = SERIES[idx];
        var x = Math.round(absIdx * SP - pan + W * 0.5);
        if (x < -SP || x > W + SP) continue;

        /* the newest column is still open: it grows out of its open price
           across the interval instead of appearing fully formed */
        var isLive = absIdx === liveAbs;
        if (isLive && !REDUCED) {
          bar = {
            o: bar.o,
            c: bar.o + (bar.c - bar.o) * formT,
            h: bar.o + (bar.h - bar.o) * formT,
            l: bar.o + (bar.l - bar.o) * formT,
            seed: bar.seed
          };
        } else if (isLive) {
        }

        var up = bar.c >= bar.o;
        var col = up ? BULL : BEAR;
        var yT = Y(Math.max(bar.o, bar.c)), yB = Y(Math.min(bar.o, bar.c));
        var bh = Math.max(4, yB - yT);
        var yH = Y(bar.h);

        var edge = Math.min(1, Math.min(x, W - x) / (W * 0.28));
        var a = 0.30 + edge * 0.62;

        ctx.strokeStyle = "rgba(" + col + "," + (a * 0.8).toFixed(3) + ")";
        ctx.lineWidth = isLive ? 2 : 1.5;
        ctx.beginPath();
        ctx.moveTo(x + 0.5, yH);
        ctx.lineTo(x + 0.5, Y(bar.l));
        ctx.stroke();

        ctx.fillStyle = "rgba(" + col + "," + a.toFixed(3) + ")";
        roundRect(ctx, x - BW / 2, yT, BW, bh, Math.min(3, BW / 4));
        ctx.fill();

        /* a single soft highlight down the left face — it is still wax */
        ctx.fillStyle = "rgba(255,255,255,0.07)";
        roundRect(ctx, x - BW / 2 + 1.5, yT + 1.5, Math.max(1.5, BW * 0.16),
                  Math.max(1.5, bh - 3), 1.5);
        ctx.fill();



        if (LIT[idx]) {
          var near = mouse.over ? Math.max(0, 1 - Math.abs(mouse.x - x) / (W * 0.22)) : 0;
          flames.push({ x: x, y: yH, a: a, seed: bar.seed, near: near, size: bh });
        }
      }

      var litVisible = 0;
      ctx.globalCompositeOperation = "lighter";
      for (var f = 0; f < flames.length; f++) {
        var fl = flames[f];
        litVisible++;
        var t = REDUCED ? 0 : now * 0.006 + fl.seed;
        var scale = (0.78 + Math.min(0.5, fl.size / 220)) * (1 + fl.near * 0.42);
        var hgt = (26 + Math.sin(t) * 3.1 + Math.sin(t * 2.7) * 1.5) * scale;
        var wid = (7.4 + Math.sin(t * 1.9) * 0.85) * scale;
        var lean = wind + Math.sin(t * 0.7) * 0.16 - fl.near * (mouse.x > fl.x ? -0.18 : 0.18);

        var gs = hgt * 4.4;
        ctx.globalAlpha = (0.36 + fl.near * 0.3) * fl.a;
        ctx.drawImage(glow, fl.x - gs / 2, fl.y - hgt * 0.55 - gs / 2, gs, gs);
        ctx.globalAlpha = 1;

        drawFlame(ctx, fl.x, fl.y - 1, wid, hgt, lean, fl.a);

        if (!REDUCED && cfg.embers && Math.random() < (W < 640 ? 0.018 : 0.035) + fl.near * 0.05) {
          embers.push({
            x: fl.x + (Math.random() - 0.5) * wid,
            y: fl.y - hgt * 0.8,
            vx: wind * 0.5 + (Math.random() - 0.5) * 0.5,
            vy: -Math.random() * 0.9 - 0.35,
            life: 1,
            size: Math.random() * 1.5 + 0.5
          });
        }
      }

      for (var e2 = embers.length - 1; e2 >= 0; e2--) {
        var p = embers[e2];
        p.x += p.vx + wind * 0.25;
        p.y += p.vy;
        p.vy -= 0.008;
        p.life -= 0.0075;
        if (p.life <= 0 || p.y < -20) { embers.splice(e2, 1); continue; }
        ctx.globalAlpha = Math.max(0, p.life) * 0.85;
        ctx.fillStyle = p.life > 0.6 ? "#FFE9A8" : "#FF9A24";
        ctx.fillRect(p.x, p.y, p.size, p.size);
      }
      if (embers.length > 420) embers.splice(0, embers.length - 420);
      ctx.globalAlpha = 1;

      if (mouse.over) {
        ctx.globalAlpha = 0.16;
        ctx.drawImage(glow, mouse.x - 190, mouse.y - 190, 380, 380);
        ctx.globalAlpha = 1;
      }
      ctx.globalCompositeOperation = "source-over";

      if (mouse.over && mouse.y > top - 40 && mouse.y < bot + 40) {
        ctx.save();
        ctx.setLineDash([2, 5]);
        ctx.strokeStyle = "rgba(180,196,210,0.30)";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(0, Math.round(mouse.y) + 0.5); ctx.lineTo(W, Math.round(mouse.y) + 0.5);
        ctx.moveTo(Math.round(mouse.x) + 0.5, top - 30); ctx.lineTo(Math.round(mouse.x) + 0.5, bot + 30);
        ctx.stroke();
        ctx.restore();
        var val = viewLo + (1 - (mouse.y - top) / (bot - top)) * span;
        var txt = val.toFixed(2);
        ctx.font = "500 10px 'JetBrains Mono', monospace";
        var tw = ctx.measureText(txt).width + 14;
        ctx.fillStyle = "rgba(10,12,15,0.92)";
        roundRect(ctx, W - tw - 12, mouse.y - 9, tw, 18, 2);
        ctx.fill();
        ctx.fillStyle = "#C9D3DB";
        ctx.fillText(txt, W - tw - 5, mouse.y + 4);
      }

      if (torch.on) {
        torch.x += (torch.tx - torch.x) * 0.075;
        torch.y += (torch.ty - torch.y) * 0.075;
        torch.r += (torch.tr - torch.r) * 0.05;
        root.style.setProperty("--csc-mx", torch.x.toFixed(1) + "px");
        root.style.setProperty("--csc-my", torch.y.toFixed(1) + "px");
        root.style.setProperty("--csc-mr", torch.r.toFixed(0) + "px");
      }

      if (hud) hud.textContent = litVisible + " LIT";
      if (photo) {
        /* the photo is inset 0 now, so scale(1.14) is the only headroom there is
           — clamp the parallax to it or the edge shows at deep scroll */
        var headroom = H * 0.06;
        var py = Math.min(headroom, (scrollY || 0) * 0.06);
        photo.style.transform = "scale(1.14) translate3d(0," + (-py).toFixed(1) + "px,0)";
      }

      /* floating product: drifts, breathes, and almost comes into focus
         at the midpoint of its sticky range before blurring away again */
      for (var fi = 0; fi < floats.length; fi++) {
        var fel = floats[fi];
        var fwrap = fel.closest(".csc-float-wrap");
        if (!fwrap) continue;
        var wr = fwrap.getBoundingClientRect();
        var fRange = wr.height - window.innerHeight;
        var prog = fRange > 0 ? Math.min(1, Math.max(0, -wr.top / fRange)) : 0;
        if (wr.bottom < -200 || wr.top > window.innerHeight + 200) continue;

        var bob = REDUCED ? 0 : Math.sin(now / 2600) * 7;
        var lift = (0.5 - prog) * 96 + bob;
        var sc = 0.93 + prog * 0.15;
        var rot = (prog - 0.5) * 3.2;
        fel.style.transform =
          "translate3d(0," + lift.toFixed(1) + "px,0) scale(" + sc.toFixed(3) + ") rotate(" + rot.toFixed(2) + "deg)";

        if (fel.getAttribute("data-csc-focus") === "true") {
          var fimg = fel.querySelector("img");
          if (fimg) {
            var baseBlur = parseFloat(fel.getAttribute("data-csc-blur")) || 18;
            var nowBlur = baseBlur * (1 - 0.34 * Math.sin(prog * Math.PI));
            fimg.style.filter = "blur(" + nowBlur.toFixed(1) + "px) saturate(1.05) brightness(1.06)";
          }
        }
      }
    }

    /* ---------- clock + idle torch ---------- */
    function pad(n) { return n < 10 ? "0" + n : "" + n; }
    function tickClock() {
      if (!clockEl) return;
      var d = new Date();
      clockEl.textContent = pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds());
    }
    var clockTimer = setInterval(tickClock, 1000);
    tickClock();

    torchTimer = setInterval(function () {
      torchIdle++;
      if (torchIdle > 7) {
        var t = Date.now() / 3400;
        root.style.setProperty("--csc-mx", (50 + Math.cos(t) * 34) + "%");
        root.style.setProperty("--csc-my", (48 + Math.sin(t * 1.3) * 26) + "%");
        root.style.setProperty("--csc-mr", "960px");
        torch.on = false;
      }
    }, 700);

    /* ---------- scroll reveals ---------- */
    var io = null;
    if ("IntersectionObserver" in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) en.target.classList.add("is-in");
        });
        /* A percentage bottom margin scales with the viewport: on a tall
           fullscreen window it pushed the trigger line above the last block,
           which then never revealed. Fixed pixels keep it predictable. */
      }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
      root.querySelectorAll(".csc-rise").forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll(".csc-rise").forEach(function (el) { el.classList.add("is-in"); });
    }

    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("pointermove", onTorchMove, { passive: true });
    C.addEventListener("pointermove", onCanvasMove, { passive: true });
    window.addEventListener("pointerleave", onLeave);
    window.addEventListener("pointerdown", onDown);
    window.addEventListener("pointermove", onMove, { passive: true });
    window.addEventListener("pointerup", onUp);
    window.addEventListener("pointercancel", onCancel);
    window.addEventListener("keydown", onKey);

    document.body.classList.add("csc-takeover");
    if (root.getAttribute("data-csc-solo") === "true") {
      document.body.classList.add("csc-solo");
    }
    resize();
    onScroll();
    lastScroll = scrollY;
    raf = requestAnimationFrame(frame);

    INSTANCES.set(root, function destroy() {
      cancelAnimationFrame(raf);
      clearInterval(clockTimer);
      clearInterval(torchTimer);
      clearTimeout(resizeTimer);
      if (io) io.disconnect();
      window.removeEventListener("resize", onResize);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("pointermove", onTorchMove);
      C.removeEventListener("pointermove", onCanvasMove);
      window.removeEventListener("pointerleave", onLeave);
      window.removeEventListener("pointerdown", onDown);
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
      window.removeEventListener("pointercancel", onCancel);
      window.removeEventListener("keydown", onKey);
      document.body.classList.remove("csc-takeover");
      document.body.classList.remove("csc-solo");
      if (stage) { /* stage markup is owned by Liquid; nothing to tear down */ }
    });
  }

  function destroy(root) {
    var fn = INSTANCES.get(root);
    if (fn) { fn(); INSTANCES.delete(root); }
  }

  function boot() {
    document.querySelectorAll("[data-csc-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Shopify theme editor: rebuild cleanly when the merchant changes a setting */
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector("[data-csc-root]");
    if (root) init(root);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    var root = e.target.querySelector("[data-csc-root]");
    if (root) destroy(root);
  });

  window.CandleStickCandle = { init: init, destroy: destroy };
})();
